<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Edit Post</h3>
        <form name="form1" @submit.prevent="save()">
          <table>
            <tr>
              <td>
                Category:
              </td>
              <td>
                <select v-model="cat" name="categorydropdown">
                  <option v-for="c in categories" :key="c.id" :value="c">
                    {{ c.category }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>
                Title:
              </td>
              <td>
                <input
                  v-model="post.title"
                  type="text"
                  name="title"
                  size="66"
                  maxlength="100"
                />
              </td>
            </tr>
            <tr>
              <td>
                Content:
              </td>
              <td>
                <textarea
                  v-model="post.content"
                  name="content"
                  cols="50"
                  rows="20"
                ></textarea>
              </td>
            </tr>
          </table>
          <p>
            <input type="submit" name="submit" value="Submit Post" />
          </p>
        </form>

        <!-- main-colum END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import PostRepository from "../../data/post.repository.js";
export default {
  data() {
    return {
      post: {
        id: "",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
  },
  created() {
    if (this.$route.params.id) {
      PostRepository.getOne(this.$route.params.id).then((p) => {
        console.log("P is " + p);
        this.post = p;
        this.cat = p.category;
      });
    } else {
      this.cat = this.categories[0];
    }
  },
  methods: {
    save() {
      this.post.category_id = this.cat.id;
      PostRepository.save(this.post)
        .then((result) => {
          this.$root.$refs.toastr.s("Post saved");
          this.$router.push("/admin");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// EditPost.vue?487ac12e